import { render, staticRenderFns } from "./ebs-locations.vue?vue&type=template&id=3f8c185d&"
import script from "./ebs-locations.vue?vue&type=script&lang=js&"
export * from "./ebs-locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports